/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2023 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import _ from 'lodash';

/**
 * Special locale case handling
 */
const SPECIAL_LOCALE_MAP = {
    zh_CN: 'zh-Hans',
    zh_TW: 'zh-Hant',
};

/**
 * Get localized message
 * @param locale
 */
export const localizedMessages = (locale) => {
    const shortLocale = stringsLocal(locale);
    try {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const messages = require(`./locale/${shortLocale}/strings.json`);
        return messages;
    } catch (error) {
        console.log(`DEV::No Locale found for the language :: ${locale}`);
    }

    // Fallback to en version for any error use case
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const defaultMessages = require('./locale/en/strings.json');
    return defaultMessages;
};

export const stringsLocal = (locale) => {
    let shortLocale = locale || 'en';
    const specialLocale = SPECIAL_LOCALE_MAP[locale];
    if (specialLocale) {
        shortLocale = specialLocale;
    } else {
        shortLocale = _.get(_.split(locale, '_'), '[0]') || 'en';
    }
    return shortLocale;
};
